<script>
import api from "../../services/api";
import Swal from "sweetalert2";

export default {
  props: {
    resourceName: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      default: function () {
        return [
          {key: "actions", sortable: false, class: "text-right", label: " "},
        ]
      }
    },
    perPage: {
      type: Number,
      default: 25
    },
    sortBy: {
      type: String,
      default: 'id'
    },
    sortDesc: {
      type: Boolean,
      default: true
    },
    filter: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    withFooter: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md'
    },
    updateListe: {
      type: Boolean,
      default: false
    },
    listProviderFields: {
      type: Object
    },
    reloadResourceOnShow: {
      type: Boolean,
      default: false
    },
    reloadResourceOnEdit: {
      type: Boolean,
      default: false
    },
    withDeleteAction: {
      type: Boolean,
      default: true
    },
    withShowAction: {
      type: Boolean,
      default: true
    },
    withEditAction: {
      type: Boolean,
      default: true
    },
    reloadResourceParameters: {
      type: Object
    },
    modalShowSize: {
      type: String,
      default: function () {
        return "lg"
      }
    },
    modalEditSize: {
      type: String,
      default: function () {
        return "xl"
      }
    }
  },
  components: {},
  data() {
    return {
      showDetails: false,
      showEditForm: false,
      totalRows: 0,
      currentPage: 1,
      selectedResource: null,
      localPerPage: this.perPage,
      localSortBy: this.sortBy,
      localSortDesc: this.sortDesc,
      localFilter: this.filter,
      pageOptions: [10, 25, 50, 100],
      localLoadParameters: {},
      isLoadingDetailsComponent: false,
      isLoadingEditComponent: false,
    };
  },
  watch: {
    updateListe: function (newVal) {
      if (newVal)
        this.$refs.resource_table.refresh();
    }
  },
  computed: {
    loadComponentDetails() {
      return () => import(`../../components/${this.localResourceNamePlur}/${this.resourceName}-details`);
    },
    loadComponentForm() {
      return () => import(`../../components/${this.localResourceNamePlur}/${this.resourceName}-form`);
    },
    localResourceNamePlur() {
      let tempResourceName = this.resourceName;
      if (this.resourceName[this.resourceName.length - 1] === "y") {
        tempResourceName = this.resourceName.substring(0, this.resourceName.length - 1);
        tempResourceName += "ie";
      }

      return (tempResourceName + "s")
    }
  },
  methods: {
    myProvider(ctx) {
      const defaultParams = {
        page: ctx.currentPage,
        length: ctx.perPage,
        filter: ctx.filter,
        sortBy: ctx.sortBy,
        sortDir: (ctx.sortDesc ? 'desc' : 'asc')
      };
      let paramsToSend = {};
      Object.assign(paramsToSend, defaultParams);
      Object.assign(paramsToSend, this.listProviderFields);

      return api.get(this.localResourceNamePlur, paramsToSend).then((response) => {
        const items = response.data.data

        this.totalRows = response.data.total;

        return (items)
      }).catch(() => {
        // Returning an empty array, allows table to correctly handle
        // internal busy state in case of error
        return []
      }).finally(() => {
        this.$emit('loadeddata');
      });
    },
    hideModal() {
      this.selectedResource = null;
      this.showEditForm = false;
      this.$refs.resource_table.refresh();
    },
    removeItem(item) {
      this.selectedResource = item;
      this.confirm();
    },
    confirm() {
      Swal.fire({
        title: this.$t('general.are_you_sure') + ' ?',
        text: this.$t('general.irreversible_action'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t('general.yes_im_sure'),
        cancelButtonText: this.$t('general.cancel'),
        preConfirm: () => {
          // eslint-disable-next-line no-unused-vars
          return api.remove(this.localResourceNamePlur, this.selectedResource.id);
        },
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          Swal.fire(this.$t('general.success').toString() + ' !', this.$t('general.deleted_entry_ok').toString(), "success");
          this.$refs.resource_table.refresh();
        }
      });
    },
    toCellName(slot) {
      return `cell(${slot})`
    },
    async setSelectedResource(resource, modal) {
      if ((modal === 'edit' && this.reloadResourceOnEdit) || (modal === 'show' && this.reloadResourceOnShow)) {
        if (modal === 'edit')
          this.isLoadingShowComponent = true;
        else if (modal === 'show')
          this.isLoadingDetailsComponent = true;

        this.localLoadParameters.id = resource.id;
        Object.assign(this.localLoadParameters, this.reloadResourceParameters);

        await api.get(
            this.localResourceNamePlur,
            this.localLoadParameters
        )
            .then((response) => {
              this.selectedResource = response.data
            })
            .finally(() => {
              if (modal === 'edit')
                this.isLoadingShowComponent = false;
              else if (modal === 'show')
                this.isLoadingDetailsComponent = false;
            });
      } else
        this.selectedResource = resource;

    }
  },
  mounted() {
  }
};
</script>

<template>
  <div>
    <b-card no-body>
      <b-card-header v-if="withHeader">
        <b-row align-v="baseline">
          <b-col>
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center text-capitalize mb-0">
                {{ $t('general.show') }}&nbsp;
                <b-form-select
                    class="form-select form-select-sm me-2 ms-2"
                    v-model="localPerPage"
                    size="sm"
                    :options="pageOptions"
                ></b-form-select
                >&nbsp;{{ $t('general.recordings') }}&nbsp;
              </label>
            </div>
          </b-col>
          <!-- Search -->
          <b-col class="text-right">
            <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end d-inline-block"
            >
              <label class="d-inline-flex align-items-center text-capitalize  mb-0">
                {{ $t('general.search') }}:
                <b-form-input
                    v-model="localFilter"
                    type="search"
                    :placeholder="$t('general.search') + '...'"
                    class="form-control form-control-sm ms-2"
                ></b-form-input>
              </label>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body class="p-0 mb-4">
        <h4 class="card-title mb-4 text-uppercase">{{ this.title }}</h4>

        <div class="table mb-0">
          <b-table
              ref="resource_table"
              :items="myProvider"
              :fields="fields"
              responsive="sm"
              hover
              :small="size === 'sm'"
              :class="size === 'sm' ? 'text-size-12': ''"
              :per-page="localPerPage"
              :current-page="currentPage"
              :sort-by.sync="localSortBy"
              :sort-desc.sync="localSortDesc"
              :filter="localFilter"
              thead-class="text-capitalize"
              table-class="mb-0"
          >

            <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="data">
              <slot :name="slot" v-bind="data"/>
            </template>

            <template #cell(actions)="data">
              <ul class="list-inline mb-0">
                <li v-if="withShowAction" class="list-inline-item px-1 text-info">
                <span
                    role="button"
                    :title="$t('general.show')"
                    @click="setSelectedResource(data.item, 'show'); showDetails = true"
                >
                  <i class="bx bx-show"></i>
                </span>
                </li>
                <li v-if="withEditAction" class="list-inline-item px-1 text-warning">
                  <span
                      role="button"
                      @click="setSelectedResource(data.item, 'edit'); showEditForm = true"
                      :title="$t('general.modify')">
                    <i class="bx bx-pencil"></i>
                  </span>
                </li>
                <li v-if="withDeleteAction" class="list-inline-item px-1 text-danger">
                  <span
                      :title="$t('general.delete')"
                      role="button"
                      @click="removeItem(data.item)">
                    <i class="bx bx-trash-alt"></i>
                  </span>
                </li>
              </ul>
            </template>
          </b-table>
        </div>
      </b-card-body>
      <b-card-footer v-if="withFooter">
        <b-row align-v="baseline">
          <b-col>
            <div class="dataTables_paginate paging_simple_numbers pagination-sm">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="localPerPage"></b-pagination>
              </ul>
            </div>
          </b-col>
          <b-col class="text-right">
            <strong>{{ totalRows }}</strong> {{ $t('general.recording' + (totalRows > 1 ? 's' : '')) }}
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal id="modal-details" :title="$t(`general.${resourceName}`)" centered hide-footer
             :size="modalShowSize"
             title-class="font-18 text-capitalize"
             v-model="showDetails"
             @close="selectedResource = null"
    >
      <component
          v-if="selectedResource"
          :is="loadComponentDetails"
          :resource="selectedResource"
          :is-loading="isLoadingDetailsComponent"
      ></component>
    </b-modal>

    <b-modal id="modal-edit" :title-html="$t(`general.${resourceName}`)" centered hide-footer
             :size="modalEditSize"
             title-class="font-18"
             v-model="showEditForm">
      <component
          v-if="selectedResource"
          :is="loadComponentForm"
          :resource="selectedResource"
          @cancel="hideModal"
          @submitted="hideModal"
      ></component>
    </b-modal>
  </div>
</template>
